import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceAppManagement-mobileAppConfigurations'

export const intuneMobileAppConfigurationsApi = createApi({
  reducerPath: 'intuneMobileAppConfigurations',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getMobileAppConfigurations: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
    }),
    getMobileAppConfigurationById: builder.query({
      query: ({ customerId, policyId }) => ({
        url: `${url}/${policyId}`,
        params: { customerId },
      }),
    }),
    deleteMobileAppConfiguration: builder.mutation({
      query: ({ customerId, userId, policyId }) => ({
        url,
        params: { customerId, userId, policyId },
        method: 'DELETE',
      }),
    }),
    createMobileAppConfiguration: builder.mutation({
      query: ({ customerId, userId, payload, source }) => ({
        url,
        body: payload,
        params: { customerId, userId, source },
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useGetMobileAppConfigurationsQuery,
  useLazyGetMobileAppConfigurationsQuery,
  useGetMobileAppConfigurationByIdQuery,
  useLazyGetMobileAppConfigurationByIdQuery,
  useDeleteMobileAppConfigurationMutation,
  useCreateMobileAppConfigurationMutation,
} = intuneMobileAppConfigurationsApi

export const useGetMobileAppConfigurations = () => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppConfigurationsQuery(customerId)
}

export const useGetMobileAppConfigurationById = ({ policyId }, options) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppConfigurationByIdQuery({ customerId, policyId }, options)
}
